import React from "react"
import { NotLarge } from "../atoms/Responsive"
import { Spacer } from "../atoms/Atoms"
import { Header } from "components/views/atoms/Header"
import { TitleWithIcon } from "./Molecules"

export const PageHeader = ({ title, icon = null, button = null }) => {
  const titleBarWithIcon = (
    <div className="flex flex-row flex-wrap justify-between items-center">
      <TitleWithIcon icon={icon} title={title} />
      {button && <div className="db-l dn-m dn fl">{button}</div>}
    </div>
  )
  return (
    <>
      <Header titleBar={titleBarWithIcon} />
      {button && (
        <NotLarge>
          <Spacer height={1} />
          {button}
        </NotLarge>
      )}
    </>
  )
}
